import Vue from 'vue'

const Machine = {
  install(Vue) {
      Vue.prototype.$machine = {
        os: (function () {
          const userAgent = window.navigator.userAgent
          const platform = window.navigator.platform
          const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
          const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
          const iosPlatforms = ['iPhone', 'iPad', 'iPod']

          if (macosPlatforms.indexOf(platform) !== -1) {
            return 'macos'
          } else if (iosPlatforms.indexOf(platform) !== -1) {
            return 'ios'
          } else if (windowsPlatforms.indexOf(platform) !== -1) {
            return 'windows'
          } else if (/Android/.test(userAgent)) {
            return 'android'
          } else if (/Linux/.test(platform)) {
            return 'linux'
          }

          return undefined
        }()),
        arch: (function () {
          const arch64 = ['x86_64', 'x86-64', 'Win64', 'x64;', 'amd64', 'AMD64', 'WOW64', 'x64_64', 'ia64', 'sparc64', 'ppc64', 'IRIX64']
          let is64 = false
          arch64.forEach(arch => {
            is64 = is64 || window.navigator.userAgent.indexOf(arch) !== -1
          })
          return is64 ? '64' : '32'
        }()),
        isDesktop: (function () {
          return !window.navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i)
        }()),
        isMobile: (function () {
          return !!window.navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i)
        }()),
        isTouchable: (function () {
          return 'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0
        }()),
        browser: (function () {
          switch (true) {
            case (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0:
              return 'opera'

            case typeof InstallTrigger !== 'undefined':
              return 'firefox'

            case /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]' })(!window['safari'] || (typeof window.safari !== 'undefined' && window.safari.pushNotification)):
              return 'safari'

            /* eslint-disable spaced-comment */
            case /*@cc_on!@*/false || !!document.documentMode:
              return 'ie'

            case !!window.StyleMedia:
              return 'edge'

            case !!window.chrome && !!window.chrome.webstore:
              return 'chrome'

            case !!window.CSS:
              return 'blink'

            default:
              break
          }

          return 'unknown'
        }())
      }
  }
}

Vue.use(Machine)
